/**
 * Mode-selection dialog — DOM port of
 *   packages/amgcommon_v2/lib/dialogs/mode_selection_dialog.dart.
 * Non-dismissible. Resolves with 'single' | 'multi'.
 */
export type GameMode = 'single' | 'multi';

export function showModeSelectionDialog(): Promise<GameMode> {
  return new Promise<GameMode>((resolve) => {
    const host = document.getElementById('dom-hud');
    if (!host) {
      resolve('single');
      return;
    }

    const backdrop = document.createElement('div');
    backdrop.className = 'mode-dialog-backdrop';

    const dialog = document.createElement('div');
    dialog.className = 'mode-dialog';

    const title = document.createElement('h2');
    title.textContent = 'MODE SELECTION';

    const row = document.createElement('div');
    row.className = 'mode-dialog-row';

    const single = makeButton('🎮', 'SINGLE PLAYER');
    const multi = makeButton('👥', 'MULTI PLAYER');

    row.append(single, multi);
    dialog.append(title, row);
    backdrop.appendChild(dialog);
    host.appendChild(backdrop);

    const cleanup = (choice: GameMode): void => {
      backdrop.remove();
      resolve(choice);
    };

    single.addEventListener('click', () => cleanup('single'));
    multi.addEventListener('click', () => cleanup('multi'));
  });
}

function makeButton(icon: string, label: string): HTMLButtonElement {
  const b = document.createElement('button');
  b.className = 'mode-btn';
  const iconEl = document.createElement('span');
  iconEl.className = 'mode-btn-icon';
  iconEl.textContent = icon;
  const labelEl = document.createElement('span');
  labelEl.textContent = label;
  b.append(iconEl, labelEl);
  return b;
}
